
import axios from 'axios'

import { format } from 'date-fns'

export default {
  methods: {
    dateFormat: function (date) {
      return format(date, 'DD-MM-YYYY').toString()
    },
    formatCurrency: function (amount, country = 'MX') {
      let tolerance = 0.01
      amount = Math.abs(0 - amount) < tolerance ? 0 : amount
      return (amount !== null && amount !== undefined) ? `$${amount.toLocaleString('en-MX', { style: 'decimal', currency: 'MXN' })}` : 0
    },
    formatUSCurrency: function (amount) {
      return `$${amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    },
    formatPercentage: function (amount, decimals = 1, percentage = true) {
      const percentageSymbol = (percentage) ? '%' : ''

      return `${parseFloat(amount).toFixed(decimals)}${percentageSymbol}`
    },
    roundBigNumbers: function (amount, decimals = 2) {
      return `${parseFloat(amount).toFixed(decimals)}`
    },
    formatIntegerNumbers: function (amount) {
      return `${Number(amount).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    },
    doScroll: function (topDistance = 0) {
      const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style

      if (isSmoothScrollSupported) {
        window.scroll({ top: topDistance, left: 0, behavior: 'smooth' })
      } else {
        window.scroll(topDistance, 0)
      }
    },
    carouselNext: function (reference) {
      this.$refs[reference].next()
    },
    carouselPrev: function (reference) {
      this.$refs[reference].previous()
    },
    goToFundingRequest: function (id) {
      if (!this.$store.getters.sessionIsAlive) {
        sessionStorage.setItem('sofom_back_to_fr', true)
        sessionStorage.setItem('sofom_fr_id', id)
        this.$router.push({ name: 'LogIn' })
      } else {
        this.$router.push({
          name: 'RequestDetail',
          params: { market: 'mx', id: `${id}` }
        })
      }
    },
    errorCodes: function (code) {
      switch (code) {
        case '0001':
          return 'Ocurrió un error inesperado. Fuimos notificados y te contactaremos para solucionarlo.'
        case '0002':
          return 'El monto de inversión es mayor al regulado por diversificación.'
        case '0003':
          return 'Ocurrió un error y no se pudo realizar la inversión. Por favor contáctanos al e-mail contacto.mx@cumplo.com o llámanos al teléfono (55) 7100 2310 para ayudarte.'
        case '0004':
          return 'Ocurrió un error interno pero tu intención de inversión fue exitosa. Si prefieres puedes confirmarlo contactándonos al e-mail contacto.mx@cumplo.com o llamarnos al teléfono (55) 7100 2310.'
        case '0005':
          return 'Ocurrió un error con tu CLABE STP. Por favor contáctanos al e-mail contacto.mx@cumplo.com o llámanos al teléfono (55) 7100 2310 para ayudarte.'
        default:
          return 'Ocurrió un error inesperado. Fuimos notificados y te contactaremos para solucionarlo.'
      }
    },
    reverseBirthDate: function (date) {
      if (date) {
        return date.split('-').reverse().join('-')
      }
    },
    checkEmail: function (email) {
      // eslint-disable-next-line
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (reg.test(email)) return false
      return true
    },
    convertArraytoString: function (data) {
      return Object.keys(data).map(key => data[key][0])
    },
    checkProtocol: function (url) {
      let protocol = url.split('//')[0]
      const uri = url.split('//')[1]
      if (protocol !== 'https:') {
        protocol = protocol.replace(/^http:/, 'https:')
      }
      return `${protocol}//${uri}`
    },
    getBalance: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/investors/balance/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      await axios(
        {
          method: options.method,
          url: options.url,
          headers: options.headers
        })
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('storeUserBalance', response.data)
          }
        })
        .catch((error) => {
          let message = error.response.data
          if (error.response.status === 500) {
            message = 'Se ha producido un error interno,' +
                  'por favor intenta nuevamente'
          }
          this.modalError(message, error.response.status)
        })
    },
    getInvestorClabe: function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/investor-profile/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      axios(
        {
          method: options.method,
          url: options.url,
          headers: options.headers,
          params: options.params
        })
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('storeUserClabe', response.data.clabe_stp)
          }
        })
        .catch((error) => {
          let message = error.response.data
          if (error.response.status === 500) {
            message = 'Se ha producido un error interno,' +
                  'por favor intenta nuevamente'
          }
          this.modalError(message, error.response.status)
        })
    },
    paginationTable: function (url, type = 'next') {
      let options = {
        method: 'GET',
        url: this.checkProtocol(url),
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      if (!this.$store.getters.getToken) {
        delete options.headers['Authorization']
      }

      axios(
        {
          method: options.method,
          url: options.url,
          headers: options.headers
        })
        .then(response => {
          if (response && response.status === 200) {
            this.list = response.data
            this.doScroll(100)
            if (type === 'next') {
              this.currentPage++
            } else {
              this.currentPage--
            }
          }
        })
        .catch((error) => {
          switch (error.response.status) {
            case 401:
              this.modalError(error.response.data, error.response.status)
              break
            default:
              this.modalError(
                {error: ['Se ha producido un error interno,' +
                  'por favor intenta nuevamente']}, error.response.status)
          }
        })
    },
    getUserData: function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/profile/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      axios(
        {
          method: options.method,
          url: options.url,
          data: options.data,
          headers: options.headers
        })
        .then(response => {
          if (response && response.status === 200) {
            this.generalInfo = response.data
            this.$store.dispatch('setUserRfc', response.data.rfc)
          }
        })
        .catch((error) => {
          switch (error.response.status) {
            case 401:
              this.modalError(error, error.response.status)
              break
            case 400:
              this.sendErrorToLogger('getUserData', error)
              break
            default:
              this.modalError(
                {error: ['Se ha producido un error interno,' +
                  'por favor intenta nuevamente']}, error.response.status)
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js